import { ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';

export const SlideToggle = <T extends string>({
	value,
	options,
	setValue,
	disabled,
}: {
	value: T;
	options: [T, T];
	setValue: (value: T) => void;
	disabled?: boolean;
}) => {
	const theme = useTheme();

	return (
		<ToggleButtonGroup
			role="radiogroup"
			disabled={disabled}
			tabIndex={0}
			value={value}
			exclusive
			onChange={(_, value: undefined | T) => {
				if (value == null) return;
				setValue(value);
			}}
			onKeyDown={(e) => {
				if (e.key === 'ArrowLeft') {
					e.preventDefault();
					setValue(options[0]);
				}
				if (e.key === 'ArrowRight') {
					e.preventDefault();
					setValue(options[1]);
				}
			}}
			onKeyUp={(e) => {
				if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
					e.stopPropagation();
				}
			}}
			sx={{
				background:
					value === options[0] ?
						`left top/50% no-repeat linear-gradient(${disabled ? theme.palette.grey[400] : theme.palette.primary.main}, grey)`
					:	`right top/50% no-repeat linear-gradient(${disabled ? theme.palette.grey[400] : theme.palette.primary.main}, grey)`,
				transition: 'background 0.2s cubic-bezier(0.55, 0.06, 0.55, 1.29)',
				border: '1px solid',
				borderColor: 'grey.500',
				'&& .MuiToggleButtonGroup-grouped': {
					border: 'none',
					backgroundColor: 'transparent',
					paddingInline: 1,
					paddingBlock: 0.5,
					color: 'grey.500',
					transition: 'color 0.2s',
					margin: 0,
				},
				'&& .MuiToggleButtonGroup-grouped.Mui-disabled': {
					border: 'none',
				},
				'& .MuiToggleButtonGroup-grouped.Mui-selected': {
					backgroundColor: 'transparent',
					color: 'white',
				},
			}}
		>
			{options.map((option) => (
				<ToggleButton
					key={option}
					value={option}
					size="small"
					tabIndex={-1}
					role="radio"
					aria-checked={value === option}
				>
					{option}
				</ToggleButton>
			))}
		</ToggleButtonGroup>
	);
};
